import Vue from 'vue';
import axios from 'axios';

const initState = {
  userSubscriptions: [],
};

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {
    setUserSubscriptions(state, subscriptions) {
      state.userSubscriptions = subscriptions;
    },
    removeUserSubscription(state, subscriptionId) {
      state.userSubscriptions = state.userSubscriptions.filter(s => s.id !== subscriptionId);
    },
    resetAll(state) {
      for (let f in state) {
        Vue.set(state, f, initState[f]);
      }
    },
  },
  actions: {
    fetchUserSubscriptions({ commit }) {
      return axios.get('/api/user/subscriptions').then(res => {
        commit('setUserSubscriptions', res.data.data);
        return res.data.data;
      });
    },
    cancelUserSubscription({ commit }, subscriptionId) {
      return axios.post(`/api/user/subscriptions/${subscriptionId}/cancel`).then(() => {
        commit('removeUserSubscription', subscriptionId);
      });
    },
    resetAll({ commit }) {
      commit('resetAll');
    },
  },
  getters: {
    allUserSubscriptions(state) {
      return state.userSubscriptions;
    },
  },
};

